import { Component, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { AppService } from "src/app/services/app/app.service";
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: 'app-job-usage',
  templateUrl: './job-usage.component.html',
  styleUrls: ['./job-usage.component.scss']
})
export class JobUsageComponent {
  displayedColumns: string[] = ['shift-date', 'clock-in', 'clock-out', 'total-hours'];
  public dataSource = new MatTableDataSource();
  public userData: any = {
    profile_picture: null,
    first_name: "Vishva",
    last_name: "Upadhyay",
    email: "vishva@cipherhex.com"
  }
  public approvedDtForm!: FormGroup;
  constructor(private commonService: CommonService, private appService: AppService, private spinner: NgxSpinnerService, private dialog: MatDialog, private timeClockService: TimeClockService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<JobUsageComponent>, private datePipe: DatePipe, private fb: FormBuilder,
  ) { }
  ngOnInit(): void {
    this.commonService.setTitle("Time Clock");
    this.loadData();
    this.getList();

    this.approvedDtForm = this.fb.group({
      start: ["", Validators.required],
      end: ["", Validators.required]
    })

    // this function is used to get the last 15 days data, end date is the today's date
    let endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd")
    var startdate;
    if (endDate) {
      startdate = moment().subtract(1, "year").format("yyyy-MM-DD");
    }
  }

  loadData(): void {
    // Example data; replace with actual data from your service or source
    const data = [
      { position: 1, fistName: 'John', lastName: 'doe', weight: '75kg', symbol: 'JD' },
      { position: 2, fistName: 'Jane', lastName: 'doe', weight: '65kg', symbol: 'JD' }
    ];
    this.dataSource.data = data; // Set the data for the dataSource
  }

  onCancel() { }
  getList() {
    let obj = {
      "tc_id": this.dialogData.params.id,
      "type": this.dialogData.params.type,
      "st_dt": this.dialogData.st_dt,
      "ed_dt": this.dialogData.ed_dt,
      "j_c": this.dialogData.j_c,
      "j_sc": this.dialogData.j_sc,
      "em_i": this.dialogData.em_i,
    }
    this.timeClockService.getSpecificInsightSub(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.msg)
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onExportCSV() {
    this.spinner.show()
    let data: {} = {
      "tc_id": this.dialogData.params.id,
      "type": this.dialogData.params.type,
      "st_dt": this.dialogData.st_dt,
      "ed_dt": this.dialogData.ed_dt,
      "em_i": this.dialogData.em_i,
    }
    this.timeClockService.exportUserWiseTimesheetCSV(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.downloadFile(success.msg, 'sample_csv')
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }


  onChangeTime(element: any) {

    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

    const isStartTimeValid = timeRegex.test(element.st_ti);
    const isEndTimeValid = timeRegex.test(element.ed_ti);

    if (!isStartTimeValid || !isEndTimeValid) {
      this.appService.showToastMessage("error", "Enter valid time format. ");
      return
    }




    let obj = {
      "j_id": element.id,
      "clock_id": element.clock_id,
      "st_ti": element.st_ti,
      "ed_ti": element.ed_ti,
      "em_i": this.dialogData.em_i,
      "date": element.date,
      "br_ti": ""
    }
    this.spinner.show();
    this.timeClockService.changeTime(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide();
          this.appService.showToastMessage("success", success["msg"]);
          this.getList()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }

}
